const CONSENT = Object.freeze({
  all: 'all',
  esssential: 'essential',
});

export default CONSENT;
